const vn = {
  // vận hành
  addProduct: "Thêm sản phẩm",

  code: "Mã hàng tồn kho",
  name: "Tên khoảng không quảng cáo",
  uom: "Đơn vị",
  cbm: "mét khối",
  brand1: "mô hình 1",
  brand2: "mô hình 2",

  // hình thức
  plCode: "Xin vui mã hàng tồn kho",
  plCodeRule: "Độ dài mã hàng tồn kho quảng cáo ít nhất là {{min}} bit và nhiều nhất là {{max}} bit.",
  plName: "Xin vui lòng nhập tên kho",
  plInputMaxRule: "Tên kho không được vượt quá {{length}} ký tự.",
  plCbm: "Xin vui lòng nhập mét khối",
  plDesc: "Vui lòng nhập mô tả",
  plBrand1: "Vui lòng nhập số model 1",
  plBrand2: "Vui lòng nhập số model 2",
  plUom: "Vui lòng chọn đơn vị đo chính",

  category: "danh mục",
  addFailed: "Thêm thất bại",
  modifySuccess: "Sửa đổi thành công",
  modifyFailed: "Sửa đổi thất bại",
  addChildNode: "Thêm nút con",
  clickModify: "Click để sửa đổi",
  serialNum: "số sê-ri",
  addCategory: "Thêm danh mục",
  addType: "Thêm loại sản phẩm",
  selProduct: "Vui lòng chọn sản phẩm",
  priPrducInfo: "In thông tin sản phẩm",
  priThisPage: "In nội dung của trang này",
  modify: "sửa đổi",
  plFill: "Vui lòng điền vào các trường bắt buộc!",
  modifyProduct: "Sửa đổi sản phẩm",
  process: "quy trình",
  processPl: "Vui lòng chọn quy trình",
  materialProcess: "Quy trình vật liệu",
  cbmDecimalLength: "Số chữ số thập phân không được vượt quá {{count}} chữ số",

  gallery: "Thư viện ảnh",
  folder: 'thư mục',
  dataError: "Lỗi dữ liệu, vui lòng liên hệ với quản trị viên để thử lại sau khi sửa đổi dữ liệu",
  productInfo: ' Thông tin về sản phẩm',
  num: 'Số lượng hàng tồn kho',
  model: 'Mẫu hàng tồn kho',
  preReady: 'Vật liệu thường trực',
  isTrue: 'Vâng',
  isFalse: 'Không',
  isDeprecated: 'Có bị hủy bỏ',
  deprecated: 'Hủy bỏ',
  normalStatus: 'Bình thường',
  notSet: 'Chưa đặt',
  returnQuantity: "Số lượng trả kho",
  noReturnQuantity: "Không có hàng trả lại",

  // Thông tin sản xuất
  createProductInfo: "Tạo thông tin sản xuất",
  editProductInfo: "Chỉnh sửa thông tin sản xuất",
  viewProductInfo: "Xem thông tin sản xuất",
  selectSaleOrder: "Chọn đơn hàng bán",
  orderNumber: "Số đơn hàng",
  erpCode: "Mã ERP",
  issueDate: "Ngày phát hành",
  customerName: "Tên khách hàng",
  customerModel: "Mẫu khách hàng",
  companyModel: "Mẫu công ty",
  productionSoftware: "Phần mềm sản xuất",
  flash: "Phần mềm Flash",
  md5Value: "Giá trị MD5",
  checksum: "Kiểm tra",
  qaToolVersion: "Phiên bản công cụ QA",
  softwareVersion: "Phiên bản phần mềm",
  macAddressContent: "Nội dung địa chỉ MAC",
  quantity: "Số lượng",
  size: "Kích thước",
  antivirusStatus: "Trạng thái antivirus",
  languageRequirement: "Yêu cầu ngôn ngữ",
  ssid: "SSID",
  initialIp: "IP ban đầu",
  finishedToolVersion: "Phiên bản công cụ thành phẩm",
  semiFinishedToolVersion: "Phiên bản công cụ bán thành phẩm",
  channelRange: "Phạm vi kênh",
  channelSelection: "Lựa chọn kênh",
  defaultChannel: "Kênh mặc định",
  functionDescription: "Mô tả chức năng",
  productionTestProgram: "Chương trình kiểm tra sản xuất",
  power: "Công suất",
  evm: "EVM",
  fer: "FER",
  smt: "SMT",
  dip: "DIP",
  test1: "Kiểm tra 1",
  assy: "Lắp ráp",
  test2: "Kiểm tra 2",
  pack: "Đóng gói",
  shipmentRequirements: "Yêu cầu giao hàng",
  plSelectSaleOrder: "Vui lòng chọn đơn hàng bán",
  attachments: "Hình ảnh đính kèm",
  uploadImage: "Tải lên hình ảnh",
  plUploadImage: "Vui lòng tải lên hình ảnh",
  uploadFailed: "Tải lên thất bại",
  imageSelected: "Đã chọn hình ảnh",
  onlyImageAllowed: "Chỉ cho phép tải lên hình ảnh",
  clickOrDragUpload: "Nhấp hoặc kéo tệp vào đây để tải lên",
  descriptionPlaceholder: "Mô tả (tùy chọn)",
  addAttachment: "Thêm hình ảnh đính kèm",
  languageZh: "Tiếng Trung",
  languageEn: "Tiếng Anh",
  languageTr: "Tiếng Trung phồn thể",
  languageVn: "Tiếng Việt",
  languageKo: "Tiếng Hàn",
  languageFr: "Tiếng Pháp",
  languageDe: "Tiếng Đức",
  languageRu: "Tiếng Nga",
  languageAdaptive: "Thích ứng",
  languagePortuguese: "Bồ Đào Nha, Khác",
  region36to165: "Vùng 36-165",
  basicInfo: "Thông tin cơ bản",
  productionInfo: "Thông tin sản xuất",
  testInfo: "Thông tin kiểm tra",
  shipmentInfo: "Thông tin giao hàng",
  delete: "Xóa",
  basicInfoDesc: "Mô tả thông tin cơ bản",
  testProgram: "Chương trình kiểm tra",
  testProgramFinished: "Chương trình kiểm tra - Phiên bản công cụ thành phẩm",
  testProgramSemiFinished: "Chương trình kiểm tra - Phiên bản công cụ bán thành phẩm",
  auto: "Tự động",
  addSuccess: "Tạo thành công",
  addSuccessDesc: "Thông tin sản xuất đã được tạo thành công",
  editSuccess: "Cập nhật thành công",
  editSuccessDesc: "Thông tin sản xuất đã được cập nhật thành công",
  editFailed: "Cập nhật thất bại",
  saleOrderAlreadyHasProductInfo: "Số đơn hàng bán: {{orderNumber}} đã tạo thông tin sản xuất",

  // Trang danh sách
  normalTab: "Bình thường",
  disabledTab: "Vô hiệu hóa",
  salesOrderNumber: "Số đơn hàng bán",
  internalNumber: "Số nội bộ",
  createdAt: "Thời gian tạo",
  updatedAt: "Thời gian cập nhật",
  action: "Hành động",
  disable: "Vô hiệu hóa",
  enable: "Kích hoạt",
  disableConfirm: "Xác nhận vô hiệu hóa",
  enableConfirm: "Xác nhận kích hoạt",
  disableConfirmDesc: "Bạn có chắc chắn muốn vô hiệu hóa thông tin sản xuất này?",
  enableConfirmDesc: "Bạn có chắc chắn muốn kích hoạt thông tin sản xuất này?",
  disableSuccess: "Vô hiệu hóa thành công",
  enableSuccess: "Kích hoạt thành công",
  disableFailed: "Vô hiệu hóa thất bại",
  enableFailed: "Kích hoạt thất bại",
  searchPlaceholder: "Vui lòng nhập ID sản phẩm hoặc tên tài liệu để tìm kiếm",
  batchExport: "Xuất hàng loạt",
  minStockCount: "Tồn kho tối thiểu",
  maxStockCount: "Tồn kho tối đa",
  minStockAgeDays: "Tuổi kho tối thiểu (ngày)",
  maxStockAgeDays: "Tuổi kho tối đa (ngày)",
  codePl: "Nhập mã vật liệu",
  alertAdd: "Thêm cảnh báo",
  alertDetail: "Thông tin cảnh báo",
  overMaxCount: "Vượt tồn kho tối đa: {{maxStockCount}}",
  lowerMinCount: "Dưới tồn kho tối thiểu: {{minStockCount}}",
  alert: "Cảnh báo",
  hh: "Độ ẩm không đổi",
  ht: "Nhiệt độ không đổi",
  va: "Chân không",
  ot: "Khác",
  storeType: "Yêu cầu bảo quản",
  storageCode: "Loại yêu cầu",
  minValue: "Giới hạn dưới",
  maxValue: "Giới hạn trên",
  unit: "Đơn vị",
  inspectionCycleDays: "Chu kỳ kiểm tra (ngày)",
};

export default vn;
